isHubsPersonalDevelopment